import {
  SET_ESSENTIAL_INFO
} from "./essential-info-action-types";

export const setEssentialInfoT = (T, text, id) => ({
  type: SET_ESSENTIAL_INFO(T),
  value: text,
  id
});
